import Swiper from "swiper/bundle";

export default class Carousel {
  constructor(elements) {
    this.element = elements;

    this.options = {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: this.element.querySelector(".swiper-pagination"),
      },
      breakpoints: {
        // When window width is >= 768px (or your target screen width)
        100: {
          slidesPerView: 1.5,
          spaceBetween: 20,
        },
        900: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
      },
    };
    this.init();
  }
  setOptions() {
    if ("slides" in this.element.dataset) {
      this.options.slidesPerView =
        parseFloat(this.element.dataset.slides) || this.options.slidesPerView;
    }
    if ("modele" in this.element.dataset) {
      this.options.slidesPerView = 2.5;
    }
  }
  init() {
    this.setOptions();
    new Swiper(this.element, this.options);
  }
}
